import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, LogOut, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const SubUserProfile = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('cop31_token');
    const userStr = localStorage.getItem('cop31_user');
    if (!token || !userStr) {
      navigate('/giris');
      return;
    }
    const user = JSON.parse(userStr);
    if (user.role !== 'sub_user') {
      navigate('/giris');
      return;
    }
    setUserData(user);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('cop31_token');
    localStorage.removeItem('cop31_user');
    navigate('/giris');
  };

  if (!userData) return null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-green-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-emerald-600 to-green-500 px-8 py-8 text-center">
            <div className="inline-flex items-center justify-center h-20 w-20 rounded-full bg-white/20 mb-4">
              <span className="text-white font-bold text-3xl">
                {(userData.full_name || userData.email || '?').charAt(0).toUpperCase()}
              </span>
            </div>
            <h1 className="text-2xl font-bold text-white">{userData.full_name}</h1>
            <p className="text-emerald-100 text-sm mt-1">{userData.email}</p>
            {userData.category_name && (
              <span className="inline-block mt-2 text-xs bg-white/20 text-white rounded-full px-3 py-1">
                {userData.category_name}
              </span>
            )}
          </div>

          {/* Body */}
          <div className="px-8 py-6 space-y-4">
            {[
              { label: 'E-posta', value: userData.email },
              { label: 'Kategori', value: userData.category_name || '—' },
              { label: 'Rol', value: 'Alt Kullanıcı' },
            ].map(({ label, value }) => (
              <div key={label} className="flex justify-between items-center py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">{label}</span>
                <span className="text-sm font-medium text-gray-800">{value}</span>
              </div>
            ))}

            <div className="pt-4">
              <Button
                onClick={handleLogout}
                variant="outline"
                className="w-full rounded-full border-red-200 text-red-600 hover:bg-red-50"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Çıkış Yap
              </Button>
            </div>
          </div>
        </div>

        <p className="text-center text-gray-500 mt-4 text-sm">
          © 2026 COP 31 Baku Blue Zone Platform
        </p>
      </div>
    </div>
  );
};

export default SubUserProfile;
